
import React, { useContext } from 'react';
import { NavContext } from '../context/NavContext';

const NavLink = ({ navLinkId, scrollToId, setClick, cta }) => {
	const { activeNavLinkId, setActiveNavLinkId } = useContext(NavContext);
	const handleClick = () => {
		setActiveNavLinkId(navLinkId);
		document.getElementById(scrollToId).scrollIntoView({ behavior: 'smooth' });
		setClick(false);
	};

	const classNames = [
		'nav-item',
		activeNavLinkId === navLinkId ? 'active' : '',
		cta ? 'nav-cta' : '',
	].filter(Boolean).join(' ');

	return (
		<li
			id={navLinkId}
			className={classNames}
			onClick={handleClick}
		>
			{navLinkId}
		</li>
	);
};

export default NavLink;
